export const episodesByMovieId: Record<
  string,
  { no: number; title: string; duration: string; synopsis: string }[]
> = {
  "an-yong-zhi-cheng": [
    {
      no: 1,
      title: "第一集 · 417 号箱",
      duration: "48 分钟",
      synopsis:
        "港口例行清点中，417 号集装箱的货物记录少了一页。顾岚接手这桩没人愿意立案的失踪案，第一次走进港务局档案室。",
    },
    {
      no: 2,
      title: "第二集 · 调度表",
      duration: "47 分钟",
      synopsis:
        "顾岚发现当晚的调度表被人重排过。老周提醒她别查太深，她却在码头监控里看到一个熟悉的身影。",
    },
    {
      no: 3,
      title: "第三集 · 慈善晚宴",
      duration: "49 分钟",
      synopsis:
        "韩阔的慈善晚宴上，顾岚第一次与这座城市的权力中心正面交锋。林知意在洗手间里听到了一段不该听的对话。",
    },
    {
      no: 4,
      title: "第四集 · 十二年前",
      duration: "46 分钟",
      synopsis:
        "一段旧新闻把案件拉回十二年前。顾岚查出当年也有一个失踪的码头工人，卷宗同样薄得可疑。",
    },
    {
      no: 5,
      title: "第五集 · 证人",
      duration: "48 分钟",
      synopsis:
        "唯一愿意开口的证人临时反悔。林知意被迫在保住父亲的工作和说出实情之间做出选择。",
    },
    {
      no: 6,
      title: "第六集 · 潮水退去",
      duration: "52 分钟",
      synopsis:
        "风暴封港，所有线索在同一个夜晚汇合。顾岚拿到那份被藏了十二年的调度记录，代价是一个她不愿接受的人。",
    },
  ],
  "wu-zhong-lai-xin": [
    {
      no: 1,
      title: "第一集 · 积压件",
      duration: "45 分钟",
      synopsis:
        "邮局清理二十年的旧信件，沈栀在纸箱底部发现一沓母亲的字迹，收件地址早已不存在。",
    },
    {
      no: 2,
      title: "第二集 · 回镇",
      duration: "44 分钟",
      synopsis:
        "沈栀回到雾山镇，本想只待三天。她在老屋的抽屉里找到了同样的一沓信封，却少了一封。",
    },
    {
      no: 3,
      title: "第三集 · 语文老师",
      duration: "46 分钟",
      synopsis:
        "退休教师认出信上的字，也认出了沈栀。他讲了一个和家里人说的完全不同的版本。",
    },
    {
      no: 4,
      title: "第四集 · 杂货铺",
      duration: "45 分钟",
      synopsis:
        "杂货铺夫妇说起那年冬天的一场大雪，沈栀第一次知道母亲曾经打算离开这座镇子。",
    },
    {
      no: 5,
      title: "第五集 · 山顶邮筒",
      duration: "47 分钟",
      synopsis:
        "守林老人带沈栀上山，讲出最后一个版本的往事。三个版本的证词终于拼成一件完整的事。",
    },
    {
      no: 6,
      title: "第六集 · 雾散",
      duration: "50 分钟",
      synopsis:
        "沈栀没有把信全部读完。她把最后一封留在山顶的旧邮筒里，然后下山。雾在天亮前散开。",
    },
  ],
  "jing-mo-de-pin-lv": [
    {
      no: 1,
      title: "第一集 · 11 秒",
      duration: "52 分钟",
      synopsis:
        "夜班研究员 Ada 在例行数据里捕捉到一段 11 秒的窄带信号，频率精确得不像自然噪声。",
    },
    {
      no: 2,
      title: "第二集 · 校准误差",
      duration: "50 分钟",
      synopsis:
        "报告被连续退回三次，理由都是设备校准。Ada 开始怀疑问题不在设备上。",
    },
    {
      no: 3,
      title: "第三集 · 注销项目",
      duration: "51 分钟",
      synopsis:
        "二十年前同一位置曾有一个观测项目，参与者全部签署了保密协议，档案被整体注销。",
    },
    {
      no: 4,
      title: "第四集 · 磁带",
      duration: "49 分钟",
      synopsis:
        "Ada 在旧仓库找到一批磁带，其中一盘只有底噪，但底噪里藏着和当前信号一致的频率。",
    },
    {
      no: 5,
      title: "第五集 · 童年片段",
      duration: "53 分钟",
      synopsis:
        "一段越来越清晰的记忆让 Ada 怀疑自己也曾是项目的一部分。她开始不敢确定哪些是回忆。",
    },
    {
      no: 6,
      title: "第六集 · 被听见",
      duration: "55 分钟",
      synopsis:
        "信号被确认是一段压缩过的人类语言。Ada 决定公开记录，然后关掉设备，走出控制室。",
    },
  ],
  "bei-fang-hang-xian": [
    {
      no: 1,
      title: "第一集 · 返航",
      duration: "50 分钟",
      synopsis:
        "科考任务结束，破冰船准备返航。无线电里传来一段断续的求救信号，坐标不在任何现行海图上。",
    },
    {
      no: 2,
      title: "第二集 · 改航",
      duration: "48 分钟",
      synopsis:
        "船长用一分钟做出改航决定。船员之间的分歧从这一分钟开始，一直延续到航程结束。",
    },
    {
      no: 3,
      title: "第三集 · 冰缝",
      duration: "51 分钟",
      synopsis:
        "船体被冰层卡住，维修组在零下三十度的甲板上作业。有人开始怀疑信号是伪造的。",
    },
    {
      no: 4,
      title: "第四集 · 旧海图",
      duration: "49 分钟",
      synopsis:
        "航海长找出三十年前的纸质海图，那条被抹掉的航道下面，标着一个没有名字的坐标点。",
    },
    {
      no: 5,
      title: "第五集 · 无线电",
      duration: "52 分钟",
      synopsis:
        "信号第三次出现，这次带着一段可以被识别的呼号。船上有人听懂了，却选择不说。",
    },
    {
      no: 6,
      title: "第六集 · 极夜",
      duration: "56 分钟",
      synopsis:
        "风暴提前到来，救援变成自救。天亮时幸存者站上甲板，没有人欢呼。",
    },
  ],
  "bai-ta-zhi-xia": [
    {
      no: 1,
      title: "第一集 · 入职",
      duration: "46 分钟",
      synopsis:
        "尹昭熙以合规顾问的身份进入白塔。十年准备，只为走进这栋楼的第十七层。",
    },
    {
      no: 2,
      title: "第二集 · 旧同事",
      duration: "45 分钟",
      synopsis:
        "她找到当年父亲的同事，对方却在见面后第二天递交了辞呈。",
    },
    {
      no: 3,
      title: "第三集 · 审计",
      duration: "47 分钟",
      synopsis:
        "一次例行审计成了她的机会。她必须在两天内找到那份被替换过的验收报告。",
    },
    {
      no: 4,
      title: "第四集 · 交易",
      duration: "46 分钟",
      synopsis:
        "有人愿意作证，条件是保住自己家人的工作。尹昭熙第一次意识到自己也在做同样的选择。",
    },
    {
      no: 5,
      title: "第五集 · 天台",
      duration: "48 分钟",
      synopsis:
        "十年前的事故现场被还原。她站在同一个位置往下看，终于明白父亲当时看见了什么。",
    },
    {
      no: 6,
      title: "第六集 · 清算",
      duration: "52 分钟",
      synopsis:
        "材料被提交给监管部门。她站在一楼大厅，看着员工一个个离开白塔。",
    },
  ],
  "xue-xian-yi-shang": [
    {
      no: 1,
      title: "第一集 · 集合",
      duration: "47 分钟",
      synopsis:
        "一支预算不足、水平参差的队伍在登山基地集合。老贺看完装备清单，沉默了很久。",
    },
    {
      no: 2,
      title: "第二集 · 适应",
      duration: "45 分钟",
      synopsis:
        "高原拉练暴露了所有人的短板。赞助商代表坚持要跟拍到六千米。",
    },
    {
      no: 3,
      title: "第三集 · 修路",
      duration: "46 分钟",
      synopsis:
        "修路组在冰壁上遇到流雪。一次本可以避免的失误，让队伍第一次出现信任裂缝。",
    },
    {
      no: 4,
      title: "第四集 · 窗口期",
      duration: "48 分钟",
      synopsis:
        "天气窗口提前关闭。冲顶还是撤退，队伍在帐篷里吵到天亮也没有结论。",
    },
    {
      no: 5,
      title: "第五集 · 再往上一点",
      duration: "49 分钟",
      synopsis:
        "有人瞒着队长继续上行。暴风雪在山脊上合拢，救援几乎不可能展开。",
    },
    {
      no: 6,
      title: "第六集 · 下山",
      duration: "52 分钟",
      synopsis:
        "只有两个人登顶，也有一位同伴留在山上。老贺说：山永远在那儿，人只有一次。",
    },
  ],
  "wu-ming-zhe-dang-an": [
    {
      no: 1,
      title: "第一集 · 错卷",
      duration: "45 分钟",
      synopsis:
        "沈默在整理卷宗时发现一张没有姓名的表格，上面三个日期，有一个还没有到来。",
    },
    {
      no: 2,
      title: "第二集 · 代号",
      duration: "44 分钟",
      synopsis:
        "档案里的代号与一份旧报纸上的化名一致。沈默第一次意识到这可能是真事。",
    },
    {
      no: 3,
      title: "第三集 · 钢笔",
      duration: "46 分钟",
      synopsis:
        "四十年前的线开始展开：一支钢笔、一次交接、一个雨夜里的暗号。",
    },
    {
      no: 4,
      title: "第四集 · 名单",
      duration: "45 分钟",
      synopsis:
        "两个人在审讯室里，就一份名单的真伪反复推敲。紧张程度不输任何动作戏。",
    },
    {
      no: 5,
      title: "第五集 · 查无此人",
      duration: "47 分钟",
      synopsis:
        "所有名册上都找不到这个名字。沈默开始明白，被抹掉本身就是一种记录。",
    },
    {
      no: 6,
      title: "第六集 · 补完",
      duration: "50 分钟",
      synopsis:
        "他把档案补上了最后一项内容，然后放回原处。有些人不需要被记住，但应该被写下来。",
    },
  ],
  "chao-xi-zhi-jian": [
    {
      no: 1,
      title: "第一集 · 葬礼",
      duration: "51 分钟",
      synopsis:
        "三兄妹回到海边老宅，计划用三天办完所有手续，然后各自回到自己的生活里。",
    },
    {
      no: 2,
      title: "第二集 · 风暴",
      duration: "50 分钟",
      synopsis:
        "渡轮停运，信号中断。被困在屋里的四个人开始整理父亲留下的旧报纸。",
    },
    {
      no: 3,
      title: "第三集 · 失踪的下午",
      duration: "49 分钟",
      synopsis:
        "一张旧照片让三十年前那个夏天被重新提起。最小的妹妹却说自己什么都不记得。",
    },
    {
      no: 4,
      title: "第四集 · 录音带",
      duration: "52 分钟",
      synopsis:
        "阁楼里找到一盘录音，父亲的声音在讲一个从来没有告诉过他们的版本。",
    },
    {
      no: 5,
      title: "第五集 · 邻居",
      duration: "50 分钟",
      synopsis:
        "住在坡下的老人说出关键的一段。三个人的记忆第一次对上了同一件事。",
    },
    {
      no: 6,
      title: "第六集 · 退潮",
      duration: "54 分钟",
      synopsis:
        "风暴过去，兄妹三人在沙滩上把骨灰撒进海里，然后一起修好了那扇落地窗。",
    },
  ],
  "chang-an-jiu-meng": [
    {
      no: 1,
      title: "第一集 · 三个字",
      duration: "44 分钟",
      synopsis:
        "小吏誊抄战报时发现原件被改过三个字。这三个字，足以让一位战死的将领变成逃兵。",
    },
    {
      no: 2,
      title: "第二集 · 副本",
      duration: "43 分钟",
      synopsis:
        "他偷偷留下了一份副本。同僚提醒他，秘书省最忌讳的就是记性太好。",
    },
    {
      no: 3,
      title: "第三集 · 名录",
      duration: "45 分钟",
      synopsis:
        "一份该不该烧掉的名录摆在案上。三个人为此争论了一整夜，谁也没有说服谁。",
    },
    {
      no: 4,
      title: "第四集 · 雪夜",
      duration: "44 分钟",
      synopsis:
        "战火逼近长安。三个人在雪夜喝酒，谁都不提明天会发生什么。",
    },
    {
      no: 5,
      title: "第五集 · 城破",
      duration: "46 分钟",
      synopsis:
        "城门失守，官署里的人四散奔逃。他把最重要的几卷书装进一个旧木箱。",
    },
    {
      no: 6,
      title: "第六集 · 落笔",
      duration: "49 分钟",
      synopsis:
        "书交给了一个不相识的少年。他回到官署坐下，笔尖落纸。那年冬天，长安下了很大的雪。",
    },
  ],
};